//引入组件模块
import CountDown from "@/components/CountDown";
//将来如果有其他组件,都可以写在这里用于统一注册
const componentsArr = [CountDown];
// 批量组件注册
const install = function (Vue) {
    componentsArr.forEach((com) => {
        Vue.component(com.name, com);
    });
};
//这个方法以后使用use的时候自动被调用
export default install;
